import React from "react";

export default function ThemeSettingsPanel({ theme, setTheme }) {
  const update = (field, value) => {
    setTheme((prev) => ({ ...prev, [field]: value }));
  };

  return (
    <div className="mb-4">
      <h2 className="text-lg font-bold mb-2">Theme Settings</h2>

      <div className="mb-3">
        <label className="block font-semibold">Color Theme</label>
        <select
          value={theme.color}
          onChange={(e) => update("color", e.target.value)}
          className="w-full mt-1 border rounded p-1"
        >
          <option value="blue">Blue</option>
          <option value="red">Red</option>
          <option value="green">Green</option>
        </select>
      </div>

      <div>
        <label className="block font-semibold">Border Radius</label>
        <select
          value={theme.borderRadius}
          onChange={(e) => update("borderRadius", e.target.value)}
          className="w-full mt-1 border rounded p-1"
        >
          <option value="none">None</option>
          <option value="md">Medium</option>
          <option value="full">Full (Rounded)</option>
        </select>
      </div>
    </div>
  );
}
